// External links configuration
export const externalLinks = {
  social: {
    x: "https://x.com/spicenet",
    telegram: "https://t.me/spicenet",
    discord: "https://discord.gg/spicenetio",
    github: "https://github.com/spicenet",
  },

  navigation: {
    quests: "#",
    gameOfLife: "/game-of-life",
    leaderboard: "#",
    learn: "https://spicenet.io/learn",
  },

  footer: {
    quests: "#",
    gameOfLife: "/game-of-life",
    leaderboard: "#",
    learn: "https://spicenet.io/learn",
    terms: "/terms",
    privacyPolicy: "/privacy",
  },

  legal: {
    terms: "/terms",
    privacy: "/privacy",
  },

  // Hero CTA
  connectWallet: "#",

  // Testnet
  documentation: "https://docs.spicenet.io",
  gameOfLife: "/game-of-life",

  // Support
  support:
    "https://discord.com/channels/984941796272521226/1251053597848764446",
};
